export var PlaceholderFormat;
(function (PlaceholderFormat) {
    PlaceholderFormat["Date"] = "date";
    PlaceholderFormat["DateTime"] = "date-time";
    PlaceholderFormat["Time"] = "time";
})(PlaceholderFormat || (PlaceholderFormat = {}));
